import { render, staticRenderFns } from "./pedidosVendas.vue?vue&type=template&id=20985ad3&scoped=true&"
import script from "./pedidosVendas.vue?vue&type=script&lang=js&"
export * from "./pedidosVendas.vue?vue&type=script&lang=js&"
import style0 from "./pedidosVendas.vue?vue&type=style&index=0&id=20985ad3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20985ad3",
  null
  
)

export default component.exports